module.exports = __webpack_public_path__ + "static/img/5g.7652ed1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/5g.jpg
// module id = HHcu
// module chunks = 0